
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/research-paper-generator",
      function () {
        return require("private-next-pages/tools/research-paper-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/research-paper-generator"])
      });
    }
  